import { Stack, Typography } from '@mui/material';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

interface IProps {
  title?: string;
}

const GroupEmptyStub: React.FC<IProps> = () => {
  const { formatMessage } = useIntl();

  return (
    <Stack alignItems="center" justifyContent="center" height="100%">
      <picture>
        <source srcSet="/images/no-schools.png, /images/no-schools@2x.png 2x" />
        <img
          className="GroupEmptyStub__image"
          src="/images/no-schools.png"
          alt={formatMessage({ id: 'groups-NoMembersYet' })}
        />
      </picture>
      <Typography variant="h3" textAlign="center">
        <FormattedMessage id="groups-NoMembersYet" />
      </Typography>
    </Stack>
  );
};

export default GroupEmptyStub;
